import { Component, Inject, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContentObserver } from '@angular/cdk/observers';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { UserDetailsService } from 'src/app/services/user-details.service';


@Component({
  selector: 'iss-src',
  templateUrl: './iss-src.component.html',
  styleUrls: ['./iss-src.component.css']
})
export class IssSrcComponent implements OnInit {

  issCdmoduleId: string = 'BMM022';

  constructor(private apiCallService: APICallService,
    private jsonDataService: JsonDataService,
    private securityService: SecurityService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<IssSrcComponent>) { }
  
  ngOnInit(): void {
    this.getIssueSource();
  }


  // Variable Initializer
  issueSourceData: any = [];

  // Issue Source Initializer
  issueSourceTableConfig: any = {
    cols: [
      {
        key: "ISS_CD",
        header: "Issue Code",
        dataType: "string"
      },
      {
        key: "ISS_NAME",
        header: "Issue Source",
        dataType: "string"
      }
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15
  }

  // Gets data for Issue Source Table
  getIssueSource() {
    try {
      this.issueSourceTableConfig.loading = true;
      this.jsonDataService.contorlLoading(true);
      this.apiCallService.getAllIssueSource({
        moduleId: this.data.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe((data: any) => {
            this.securityService.checkRequestKeyResponse(data, () => {
              this.securityService.hasValidCsrfToken(data, () => {
                if (data.status === "SUCCESS") {
                  data = JSON.parse(this.jsonDataService.decrypt(data.response));
                  if (data.moduleId === this.issCdmoduleId) {
                      this.jsonDataService.contorlLoading(false);
                      this.issueSourceTableConfig.loading = false;
                      this.issueSourceTableConfig.tblData = data.data.filter((e: any) => e.ACTIVE_TAG == 'A');
                  } else {
                      this.jsonDataService.contorlLoading(false);
                      this.issueSourceTableConfig.loading = false;
                      this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
                  }
                } else {
                    this.jsonDataService.contorlLoading(false);
                    this.issueSourceTableConfig.loading = false;
                    this.appMessageService.showAppMessage(data.message, "error");
                }
              });
            });
      });
    } 
    catch(e) {
      
    }
  }

  onRowClick(ev: any) {
    try {
      this.data = ev;
    }
    catch(e) {
      
    }
  }

  onClose() {
    try {
      if(this.data=='' || this.data==null){
        this._dialogRef.close({content: ''}); 
      } else {
        this._dialogRef.close({content: this.data, moduleId: this.data.moduleId});
      }
    }
    catch(e) {
      
    }
  }

  onBack() {
    try {
      this._dialogRef.close({content: '', option: 'back'});
    }
    catch(e) {
      
    }
  }

}

